import { LinkedText } from '~/util/linked-text'
import type { checklistItemDialogModel, checklistAttachmentModel } from './selectors'
import { Button, Dialog, DialogButtons } from '@st/theme'
import type { ChecklistMessage } from '~/features/checklists/module'
import { ChecklistAttachments } from '~/features/checklists/attachments'

export function ChecklistItemDialog({
  model,
  subject,
  isAttachmentPickerOpen,
  onClose,
  send
}: {
  model: ReturnType<typeof checklistAttachmentModel>
  subject: ReturnType<typeof checklistItemDialogModel>
  isAttachmentPickerOpen: boolean
  send: (message: ChecklistMessage) => void
  onClose: () => void
}) {
  return (
    <Dialog
      title={subject.title}
      subtitle={
        <span className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
          <span>{subject.name}</span>
          {subject.note && (
            <span className="min-w-0 whitespace-pre-wrap break-words">
              <LinkedText text={subject.note} />
            </span>
          )}
        </span>
      }
      className="h-auto max-h-svh w-full rounded-md shadow-md"
      buttons={
        <DialogButtons>
          <Button variant="subtle" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={() => send({ type: 'saveChecklistDialog' })}>{subject.action}</Button>
        </DialogButtons>
      }
    >
      <ChecklistAttachments
        send={send}
        model={model}
        isAttachmentPickerOpen={isAttachmentPickerOpen}
        emptyLabel={subject.emptyLabel}
      />
    </Dialog>
  )
}
